import { type PropsWithChildren } from 'react';
import classNames from 'classnames';

import styles from './styles/SortingLayout.module.css';

export default function SortingLayout({ children }: PropsWithChildren) {
  return (
    <main className={classNames(styles.sorting)} data-iframe-size id="main">
      {children}
    </main>
  );
}
